module.exports = __webpack_public_path__ + "static/media/interactiveRocket.346e34b0.mp4";